import React from 'react';
import './styles.css';

const Card = ({ image, title, text, additionalText, imagePosition }) => {
  return (
    <div className='card-container'>
        <div className={`card ${imagePosition === 'left' ? 'left' : 'right'}`}>
            <div className="card-image-container">
                <img src={image} alt={`${title}`} />
            </div>
            <div className="card-text-container">
                <h2 class="card-h2">{title}</h2>
                <div class="card-p" dangerouslySetInnerHTML={{ __html: text }} />

            </div>
        </div>
        <div class="card-p" dangerouslySetInnerHTML={{ __html: additionalText }} />
    </div>
  );
};

export default Card;
